"use client";

import { c as _c } from "react/compiler-runtime";
import { numberFormatter } from "../formatters/number";
import { useLocale } from "./useLocale";
export const useNumberFormatter = () => {
  const $ = _c(2);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = numberFormatter(locale);
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};